/**
 * 通用的 shareCode 获取商品ID
 */
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('goods/vip', [
      'goodsDetail'
    ]),
    ...mapGetters('args', [
      'goodsIds',
      'shareCode'
    ]),
    // shareCode 转换后的 goodsId
    defaultGoods() {
      const { goodsDetail: list } = this
      return list.length ? list[0] : {}
    },
    defaultGoodsId() {
      return this.defaultGoods.goodsId
    }
  },
  created() {
    const goodsIds = this.goodsIds || '';
    this.goodsIdArr = goodsIds ? goodsIds.split('-').map(parseInt) : [];
    this.getGoodsDetail()
  },
  methods: {
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      const { goodsDetail: list } = this
      if (list.length === 1) {
        // USER-LOGIN-NEXT-ACTION: {"type":"button","action":"buyGoods"}
        this.enterAfterLogin(list)
      }
    },
    // 商品详情查询后，检查购买行为
    enterAfterLogin(res) {
      const { goodsInfoList: list } = res
      // 先处理单商品
      if (list && list.length !== 1) {
        return list
      }
      const action = this.$actionName
      return this.$store.dispatch('user/login/enterAfterLogin', { action })
        .then(action => {
          this.$nextTick(this.onClickPay)
          return action
        })
    },
    // 获取详情
    getGoodsDetail() {
      const params = this.getGoodsDetail_params
      const data = {
        goodsIds: this.goodsIdArr || [],
        shareCode: this.shareCode || '',
        ...(params && params()) // 插入动态参数
      }
      this.$store.dispatch('goods/vip/getDetailByGoodsId', data)
        // 检查支付操作（登录成功之后）继续
        .then(this.enterAfterLogin)
    }
  }
}